import { useCallback } from 'react';
import { option } from 'fp-ts';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { useRestMutation } from 'utils/hooks/api';
import { CATALOG_PREVIEW } from 'api/CatalogAPI';
import { ApiMethod } from 'services/api';
import { CatalogPreviewResult } from '../types';

export type CatalogPreviewResultsResponse = {
  count: number;
  results: CatalogPreviewResult[];
};

export type CatalogPreviewResultsRequest = {
  searchQuery: CompleteQuery;
  catalogName: string;
};

/** hook to fetch preview results for catalog preview table */
export const useCatalogPreviewResults = () => {
  const { catalog } = useCatalogContext();
  const catalogName = option.toUndefined(catalog)?.name;
  const {
    mutate,
    data: { results = [] } = {},
    isLoading,
  } = useRestMutation<CatalogPreviewResultsResponse, CatalogPreviewResultsRequest>(
    CATALOG_PREVIEW,
    ApiMethod.post,
  );

  const previewResults = useCallback(
    (searchQuery: CompleteQuery) => {
      if (catalogName) mutate({ searchQuery, catalogName });
    },
    [catalogName],
  );

  return {
    previewResults,
    catalogPreviewResults: results,
    isLoading,
  };
};
